import { AppImpl } from "core/controller/App"
import type { Module } from "core/controller/Module"

export function useModule<M extends Module>(moduleType: string): M {
  return AppImpl.theApp.moduleManager.getModule<M>(moduleType)
}
